import React from 'react'
import style from "./inputs.module.css"
import { Search } from '@mui/icons-material'

export const SearchInput = ({ ...props }) => {
    return (
        <div className={style.searchInput_con}>
            <div className={style.search_icon}><Search /></div>
            <input placeholder='Search' {...props} className={style.searchInput} />
        </div>
    )
}
